import React from "react";
import { NumericFormat } from "react-number-format";
import Title from '../../basics/Title';
import { createDataTestId, AutomationTestIdFeature, AutomationTestIdElementType } from "../../../../utilities/automation";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

export default (props) => {
    const { lang } = useLanguage();
    const dataTestId = createDataTestId({feature: AutomationTestIdFeature.MRQT_CALCULATOR, element: AutomationTestIdElementType.TEXT, specifier: 'total_costs'})

    return (
        <div className="d-none d-md-flex row mt-4">
            <div className="col-lg-12 border border-bottom-0 border-left-0 border-right-0 mrqt-col-md-6 mrqt-col-12 pt-3 px-4 pb-0">
                <Title>{getTranslation(lang).totalClosingCosts} : <NumericFormat value={props.totalClosingCost} thousandSeparator={true} prefix={"$"} displayType={"text"} data-test-id={dataTestId}/></Title>
            </div>
        </div>
    );
};